// Main Landing Page Entry Point
//
// On the platform's own domain: our marketing page, unchanged.
// On an institute's own domain: our home page only when Manage Institutes ->
// Home Page says "Platform home page"; otherwise their published website
// (Build My Site); without one, their landing URL if they gave one
// (Domain & Web App -> landing URL), otherwise their branded sign-in
// (features/site/public/TenantWebsite).
import React from 'react';

import { useBranding } from '@/contexts/BrandingContext';
import { isPlatformHost } from '@/http';
import { PageLoadingFallback } from '@/routes/LazyRoutes';
import LandingPage from '../LandingPage';

const TenantWebsite = React.lazy(() => import('@/features/site/public/TenantWebsite'));

export default function Index() {
  const { isPlatform, loading, landingMode } = useBranding();

  if (isPlatformHost()) return <LandingPage />;
  if (loading) return <PageLoadingFallback />;
  if (isPlatform || landingMode === 'platform_home') return <LandingPage />;
  return (
    <React.Suspense fallback={<PageLoadingFallback />}>
      <TenantWebsite />
    </React.Suspense>
  );
}
